import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { ServiceResponseData } from "../ServiceResponseData";
import { SetNotificationSubscriptionReqData } from "./SetNotificationSubscriptionReqData";

const ENDPOINT = "/notifications/subscriptions";

export class SetNotificationSubscriptionCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: SetNotificationSubscriptionReqData;

    constructor(payload: SetNotificationSubscriptionReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<ServiceResponseData> {
        var res = await this.executeCommand(this.payload);
        return new ServiceResponseData(res);
    }
}
